// Shim for parse@1.11.1's server-side xmlhttprequest dependency.
// In a browser environment, redirect to the native XHR implementation.
module.exports = { XMLHttpRequest: window.XMLHttpRequest };
